/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const EmployeeIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 72 57"
    onClick={props.onClick}
  >
    <g fill="none">
      <g strokeWidth="2" transform="translate(1.5 1.5)">
        <path d="M12 12v42h12v-2.25a5.263 5.263 0 0 1 5.25-5.25c2.886 0 5.25 2.361 5.25 5.25V54h12v-2.25a5.263 5.263 0 0 1 5.25-5.25c2.886 0 5.25 2.361 5.25 5.25V54h12V12H12z" />
        <path strokeLinecap="round" d="M57 6V0H0v42h6" />
        <circle cx="30" cy="25.287" r="4.5" />
        <path d="M30 29.766c-6.429 0-9 5.439-9 9.297h18c0-3.858-2.571-9.297-9-9.297zM46.5 36h15M46.5 30h15M46.5 24H54" />
      </g>
    </g>
  </svg>
);

export default EmployeeIcon;
